exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._28-2Narl76vxO39rlq3Zx3{margin:0 0 20px 0;font-size:13px;border:1px solid #c8c8c8;border-radius:2px;cursor:pointer;display:block;text-align:center;padding:10px}._28-2Narl76vxO39rlq3Zx3 ._2D6rA_RLxI5Dn_RWMsOSio{color:#757575;margin-bottom:10px}._28-2Narl76vxO39rlq3Zx3 ._1TGGx_LqniZMYFgFEVWbwA{color:#757575;margin-top:10px}._28-2Narl76vxO39rlq3Zx3._25GvOzGcM5j729UhUyuUbB{border:1px solid #fa6400}._28-2Narl76vxO39rlq3Zx3._3fy9nRyldJCYgoX8K-hHWC{border:1px solid #ff3940}\n", ""]);

// Exports
exports.locals = {
	"ImageUpload": "_28-2Narl76vxO39rlq3Zx3",
	"hintTop": "_2D6rA_RLxI5Dn_RWMsOSio",
	"hintBottom": "_1TGGx_LqniZMYFgFEVWbwA",
	"active": "_25GvOzGcM5j729UhUyuUbB",
	"reject": "_3fy9nRyldJCYgoX8K-hHWC"
};